import React from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect, useMemo } from "react";
import { resolveLaunchDarklyContext } from "./resolveLaunchDarklyContext";
import { getItem } from "utils/localStorage";

// Singleton pattern to ensure asyncWithLDProvider is called only once

const LaunchDarklyContextChangeListener = () => {
  
  const authInfo = JSON.parse(getItem("authInfoLaunchDarkly"));
  const { userEmail, userId, isGuestUser } = authInfo || {};

  const ldClient = useLDClient();

  const ctx = useMemo(() => {
    return resolveLaunchDarklyContext({ userEmail, userId, isGuestUser });
  }, [isGuestUser, userEmail, userId]);

  useEffect(() => {
    if (!ldClient) {
      return;
    }
    const prevContext = ldClient.getContext();
    if (ctx?.user?.anonymous === true && prevContext?.user?.anonymous === true) {
      return;
    }
    if (prevContext?.user?.key !== ctx?.user?.key) {
      ldClient.identify(ctx, undefined, () => {
        // console.log("New context's flags available");
      });
    }
  }, [ctx, ldClient]);

  // eslint-disable-next-line react/react-in-jsx-scope
  return <></>;
};

export default LaunchDarklyContextChangeListener;
